/* eslint-disable */
import api from '../../../api/user'
import router from '../../../router'

const actions = {
    async login({ dispatch, commit }, user) {
        const response = await api.login(user)
        localStorage.setItem("refresh", response.data.token.refresh);
        localStorage.setItem("access", response.data.token.access);
        localStorage.setItem("is_admin", response.data.is_admin);
        console.log(response)
        return response.data
    },

    async getSwtichToken() {
        const response = await api.getSwtichToken()
        return response.data
    },

    async logout({ dispatch, commit }) {
        await api.logout()
    },
}
export default actions
